import { Translations } from '../modules/localization/types'
import da from './da.json'
import en from './en.json'
import se from './se.json'
import no from './no.json'

const translations: { [ language: string ]: Translations } = {
  da, en, se, no
}

export default translations
